/**
 * ProductImageService
 * Service for ProductImage entity operations
 * Route: api/product-images
 * Controller: ProductImagesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProductImageService
 * Handles product image CRUD operations and image management
 */
export class ProductImageService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProductImageService.DEFAULT_SERVICE_PATH,
            basePath: ProductImageService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== FILTERED LIST ====================
    /**
     * Get all product images with optional product filter
     * GET /api/product-images?productId={productId}
     * @param productId - Optional product ID to filter images
     * @returns Array of product images
     */
    async getAll(productId) {
        const response = await this.getAllRaw(productId);
        return response.data ?? [];
    }
    /**
     * Get all product images with optional product filter (raw)
     * @param productId - Optional product ID to filter images
     * @returns ResponseData with product images
     */
    getAllRaw(productId) {
        const url = this.buildUrlWithParams(undefined, { productId });
        return this.http.get(url);
    }
    // ==================== PRIMARY IMAGE ====================
    /**
     * Set an image as primary
     * PUT /api/product-images/{id}/set-primary
     * @param id - Image ID
     * @returns Updated product image
     */
    async setPrimary(id) {
        const response = await this.setPrimaryRaw(id);
        if (!response.data) {
            throw new Error(`Failed to set product image ${id} as primary`);
        }
        return response.data;
    }
    /**
     * Set an image as primary (raw)
     * @param id - Image ID
     * @returns ResponseData with updated product image
     */
    setPrimaryRaw(id) {
        const endpoint = this.getEndpoint('set-primary', `${id}/set-primary`);
        const url = this.buildUrl(endpoint);
        return this.http.put(url, {});
    }
}
ProductImageService.DEFAULT_SERVICE_PATH = 'products';
ProductImageService.BASE_PATH = 'api/product-images';
//# sourceMappingURL=ProductImageService.js.map